import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Hamburger = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("rect", { x: "2", y: "10.4", fill: "#2C2C2A", width: "20", height: "3.2" }),
    React.createElement("rect", { x: "2", y: "3.4", fill: "#2C2C2A", width: "20", height: "3.2" }),
    React.createElement("rect", { x: "2", y: "17.4", fill: "#2C2C2A", width: "20", height: "3.2" })), 'Hamburger');
export default Hamburger;
